import { render, staticRenderFns } from "./tui1.vue?vue&type=template&id=4948889f&scoped=true&"
import script from "./tui1.vue?vue&type=script&lang=js&"
export * from "./tui1.vue?vue&type=script&lang=js&"
import style0 from "./tui1.vue?vue&type=style&index=0&id=4948889f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948889f",
  null
  
)

export default component.exports